// mock an array 13 objects with name, occupation, bio, video url

let candidates = [
  {
    firstname: "Ja'Mal",
    lastname: "Green",
    ballotorder: 1,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Community activist",
    dob: "08/09/1995",
    civic: "",
    candidatevideo: "https://youtu.be/uiWhxoR9Tv0",
    website: "",
    fb: "https://www.facebook.com/Jaymalgreen",
    twitter: "@JaymalGreen",
    ig: "https://www.instagram.com/jaymalgreen/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/jaymalgreen/",
    statement: "",
  },
  {
    firstname: "Sophia",
    lastname: "King",
    ballotorder: 2,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Alderperson, 4th Ward",
    dob: "02/14/1966",
    civic: "",
    candidatevideo: "https://youtu.be/BfT4ShiJz8A",
    website: "",
    fb: "https://www.facebook.com/aldsophiaking",
    twitter: "@aldsophiaking",
    ig: "https://www.instagram.com/aldsophiaking/?hl=en",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Kam",
    lastname: "Buckner",
    ballotorder: 3,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "State representative",
    dob: "05/12/1985",
    civic: "",
    candidatevideo: "https://youtu.be/3DS4uXNcqzo",
    website: "",
    fb: "https://www.facebook.com/RepKamBuckner",
    twitter: "@RepKamBuckner",
    ig: "https://www.instagram.com/kambucknerchi/",
    tiktok: "https://www.tiktok.com/@repkambuckner",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/kam-buckner-7b29613a/",
    statement: "",
  },
  {
    firstname: "Willie L.",
    lastname: "Wilson",
    ballotorder: 4,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Businessman",
    dob: "06/16/1948",
    civic: "",
    candidatevideo: "https://youtu.be/ZMECtDM9MSE",
    website: "",
    fb: "https://www.facebook.com/DrWillieWilson",
    twitter: "@DrWillieWilson",
    ig: "https://www.instagram.com/williewilsonforsenate/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Brandon",
    lastname: "Johnson",
    ballotorder: 5,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Cook County commissioner",
    dob: "03/28/1976",
    civic: "",
    candidatevideo: "https://youtu.be/_dVyIRl4Q0o",
    website: "",
    fb: "https://www.facebook.com/Brandon4Chicago",
    twitter: "@Brandon4Chicago",
    ig: "https://www.instagram.com/brandon4chicago/",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
  {
    firstname: "Paul",
    lastname: "Vallas",
    ballotorder: 6,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Former city budget director",
    dob: "06/10/1953",
    civic: "",
    candidatevideo: "https://youtu.be/SZygZC79XhM",
    website: "",
    fb: "https://www.facebook.com/PaulGVallas",
    twitter: "@PaulVallas",
    ig: "https://www.instagram.com/paulgvallas/",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/paul-vallas-b2564816a/",
    statement: "",
  },
  {
    firstname: "Lori E.",
    lastname: "Lightfoot",
    ballotorder: 7,
    "ward#": "",
    "incumbent?": "TRUE",
    "pd#": "",
    occupation: "Mayor of Chicago",
    dob: "08/04/1962",
    civic: "",
    candidatevideo: "https://youtu.be/xNa1ePyJWK0",
    website: "",
    fb: "https://www.facebook.com/LightfootForChicago",
    twitter: "@LoriLightfoot",
    ig: "https://www.instagram.com/chicagosmayor/",
    tiktok: "https://www.tiktok.com/@mayorlightfoot?lang=en",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/lori-lightfoot-27a60aa/",
    statement: "",
  },
  {
    firstname: "Roderick T.",
    lastname: "Sawyer",
    ballotorder: 8,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Alderperson, 6th Ward",
    dob: "04/12/1963",
    civic: "",
    candidatevideo: "https://youtu.be/3TLGPHIGGo0",
    website: "",
    fb: "https://www.facebook.com/SawyerforChicago",
    twitter: "@Sawyer4Chicago",
    ig: "",
    tiktok: "",
    youtube: "",
    linkedin: "https://www.linkedin.com/in/roderick-t-sawyer-29842634/",
    statement: "",
  },
  {
    firstname: "Jesús “Chuy”",
    lastname: "García",
    ballotorder: 9,
    "ward#": "",
    "incumbent?": "FALSE",
    "pd#": "",
    occupation: "Congressman, 4th District",
    dob: "04/12/1956",
    civic: "",
    candidatevideo: "https://youtu.be/OlNHrYpJaq8",
    website: "",
    fb: "https://www.facebook.com/ChuyForChicago/",
    twitter: "@RepChuyGarcia",
    ig: "https://www.instagram.com/repchuygarcia/?hl=en",
    tiktok: "",
    youtube: "",
    linkedin: "",
    statement: "",
  },
];

candidates = candidates.map((c) => {
  c.dob = new Date(c.dob);
  const today = new Date();
  let birthDate = today.getFullYear() - c.dob.getFullYear();
  const m = today.getMonth() - c.dob.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < c.dob.getDate())) {
    birthDate--;
  }
  const age = birthDate;

  c.dob = `${age} years old`;
  if (c.candidatevideo) {
    c.candidatevideo = c.candidatevideo.replace(
      "youtu.be",
      "www.youtube.com/embed"
    );
    c.candidatevideo = c.candidatevideo + "?modestbranding=1&rel=0";
  }
  return c;
});
